const STORAGE_KEY_COURSE_DRAFT = 'course_draft';

export default {
    get() {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY_COURSE_DRAFT));
        } catch (_) {
            return null;
        }
    },
    set(draft) {
        localStorage.setItem(STORAGE_KEY_COURSE_DRAFT, JSON.stringify(draft));
    },
};



// WEBPACK FOOTER //
// ./src/store/course/draft.js